var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6432 4.23756C15.6432 6.45855 17.4463 8.25902 19.6705 8.25902C19.9155 8.25782 20.1598 8.23431 20.4004 8.18878V16.1615C20.4004 19.5156 18.4219 21.5 15.0628 21.5H7.74675C4.3789 21.5 2.40039 19.5156 2.40039 16.1615V8.8561C2.40039 5.50195 4.3789 3.5 7.74675 3.5H15.7135C15.6663 3.743 15.6427 3.99001 15.6432 4.23756ZM13.55 14.3966L16.4079 10.7088V10.6912C16.6525 10.3625 16.5901 9.89889 16.2672 9.64634C16.1109 9.52568 15.9123 9.47345 15.7167 9.50159C15.5212 9.52972 15.3454 9.6358 15.2296 9.79561L12.8202 12.8951L10.0767 10.7351C9.92003 10.6131 9.72077 10.5592 9.52388 10.5856C9.32698 10.6121 9.14905 10.7166 9.03026 10.8756L6.07569 14.6863C5.97183 14.8158 5.91592 14.9771 5.91741 15.1429C5.90026 15.4781 6.11194 15.7826 6.43244 15.8838C6.75295 15.985 7.10144 15.8573 7.28038 15.5732L9.75131 12.3771L12.4948 14.5283C12.6509 14.6541 12.8515 14.7111 13.0505 14.6863C13.2495 14.6615 13.4298 14.5569 13.55 14.3966Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 19.9004,
    cy: 4,
    rx: 2.5,
    ry: 2.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.e684a65aab7b2d43f890a60c4d448d4c.svg";
export { ForwardRef as ReactComponent };